import { render, staticRenderFns } from "./AbnormalAttendance.vue?vue&type=template&id=0855a4c0&"
import script from "./AbnormalAttendance.vue?vue&type=script&setup=true&lang=js&"
export * from "./AbnormalAttendance.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports